import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { fetchExchangeRates } from "./commerce/cart/CartSlice";
// import Navbar from './components/Navbar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Homepage from './pages/Home';
import Contact from './pages/Contact';
import Bio from './pages/about/Bio';
import Faq from './pages/about/Faq';
import Exhibition from './pages/about/Exhibition';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Portfolio from './pages/Portfolio';
import CV from './pages/CV';
import NotFound from './pages/NotFound';
import ExhibitionDetail from './pages/about/ExhibitionDetail';
import Motions from './pages/Motions';
import FrontOnset from './pages/Onset';
import GearList from './pages/GearList';
import Overview from './pages/overview/Overview';
import Preloader from './components/Pre';
import Shop from "./commerce/Shop";
import ProductPage from "./commerce/ProductPage";
import ProductDetail from "./pages/ProductDetail";

import Login from './test/Login';
import RegisterFront from './test/Register';
import Dashboard from './test/Dashboard';
import Success from './pages/Success';
import ProtectedRoute from './test/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';

import Adminblog from './admin/Blog';
import PostBlog from './admin/PostBlog';
import EditBlog from './admin/EditBlog';
import Register from './admin/Register';
import AdminContact from './admin/Contact';
import AdminAcademy from './admin/Academy';
import Subscribers from './admin/Subscribers';
import Brand from './admin/BrandForm';
import ExhibitionAdmin from './admin/ExhibitionForm';
import EditBrand from './admin/EditBrandForm';
import SubBrand from './admin/SubBrandForm';
import ImageUploadForm from './admin/ImageUploadForm';
import ExhibitionUploadForm from './admin/ExhibitionUploadForm';
import UploadProduct from './admin/UploadProduct';
import SubbrandImageUpload from './admin/SubbrandImageUpload';
import AdminPortfolio from './admin/Portfolio';
import Home from './admin/Index';
import CreatePost from './admin/CreatePost';
import Orders from './admin/Orders';
import Onset from './admin/Onset';
import About from './admin/About';
import CvAdmin from './admin/Cv';
import BackHomepage from './admin/Homepage';
import Users from './admin/User';

// This component helps in conditionally rendering Navbar based on route
function Layout() {

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  // const isShopRoute = location.pathname.startsWith('/prints');

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchExchangeRates());
  }, [dispatch]);

  return (
    <>
      <AuthProvider>
      {/* Render Navbar only if it's not an admin route */}
      {!isAdminRoute && <Navbar />}

      {/*<Navbar />*/}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/learn-more" element={<Bio />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/about/faq" element={<Faq />} />
        <Route path="/thoughts" element={<Blog />} />
        <Route path="/thoughts/:slug" element={<BlogPost />} />
        <Route path="/portfolios/:brandName" element={<Portfolio />} />
        {/* One dynamic page per overview title — driven by the admin panel */}
        <Route path="/overview/:titleSlug" element={<Overview />} />
        <Route path="/exhibitions/:brandName" element={<ExhibitionDetail />} />
        <Route path="/motions" element={<Motions />} />
        <Route path="/on-set" element={<FrontOnset />} />
        <Route path="/gear-list" element={<GearList />} />
        <Route path="/exhibitions" element={<Exhibition />} />

        

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterFront />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        <Route 
          path="/success" 
          element={
            <ProtectedRoute>
              <Success />
            </ProtectedRoute>
          } 
        />

        <Route path="/prints" element={<Shop />} />
        <Route path="/prints/:id" element={<ProductDetail />} />
        <Route path="/product/:productId" element={ProductPage} />

        <Route path="/admin/blog" element={<Adminblog />} />
        <Route path="/admin/blog/:id" element={<PostBlog />} />
        <Route path="/admin/edit/:id" element={<EditBlog />} />
        <Route path="/admin/register" element={<Register />} />
        <Route path="/admin/contact" element={<AdminContact />} />
        <Route path="/admin/academy" element={<AdminAcademy />} />
        <Route path="/admin/subscribers" element={<Subscribers />} />
        <Route path="/admin/portfolio-title" element={<Brand />} />
        <Route path="/admin/exhibition-title" element={<ExhibitionAdmin />} />
        <Route path="/admin/editbrand" element={<EditBrand />} />
        <Route path="/admin/upload-product" element={<UploadProduct />} />
        <Route path="/admin/subbrand" element={<SubBrand />} />
        <Route path="/admin/upload-to-portfolio" element={<ImageUploadForm />} />
        <Route path="/admin/upload-to-exhibition" element={<ExhibitionUploadForm />} />
        <Route path="/admin/upload-to-subportfolio" element={<SubbrandImageUpload />} />
        <Route path="/admin/portfolio/:id" element={<AdminPortfolio />} />
        {/*<Route path="/admin/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />*/}
        <Route path="/admin/home" element={<Home />} />
        <Route path="/admin/create" element={<CreatePost />} />
        <Route path="/admin/orders" element={<Orders />} />
        <Route path="/admin/on-set" element={<Onset />} />
        <Route path="/admin/about" element={<About />} />
        <Route path="/admin/cv" element={<CvAdmin />} />
        <Route path="/admin/homepage-upload" element={<BackHomepage />} />
        <Route path="/admin/users" element={<Users />} />

        {/* Catch-all 404 — must stay last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      </AuthProvider>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a network request or loading process
    const timer = setTimeout(() => setLoading(false), 2500); // Adjust duration as needed
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loading ? (
        <Preloader /> // Show preloader while loading
      ) : (
        <BrowserRouter>
          <Layout /> {/* Render layout with conditional Navbar */}
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
